import getNextConfig from '@maxpreps/shared/constants/getNextConfig';

const { appEnv } = getNextConfig().publicRuntimeConfig;

const devAdminOrigin = 'https://admin-dev.maxpreps.com';
const adminOrigins = {
  dev: devAdminOrigin,
  development: devAdminOrigin,
  staging: 'https://admin-staging.maxpreps.com',
  production: 'https://admin.maxpreps.com'
};

const devPublicOrigin = 'https://dev.maxpreps.com';
const publicOrigins = {
  dev: devPublicOrigin,
  development: devPublicOrigin,
  staging: 'https://staging.maxpreps.com',
  production: 'https://www.maxpreps.com'
};

const devSecureOrigin = 'https://secure-dev.maxpreps.com';
const secureOrigins = {
  dev: devSecureOrigin,
  development: devSecureOrigin,
  staging: 'https://secure-staging.maxpreps.com',
  production: 'https://secure.maxpreps.com'
};

const devImageOrigin = 'https://image-development.maxpreps.io';
const imageOrigins = {
  dev: devImageOrigin,
  development: devImageOrigin,
  staging: 'https://image-staging.maxpreps.io',
  production: 'https://image.maxpreps.io'
};

const devVideoElasticSearchServiceOrigins =
  'https://video-dev.search.maxpreps.com';
const productionVideoElasticSearchServiceOrigins =
  'https://video.search.maxpreps.com';
const videoElasticSearchServiceOrigins = {
  dev: devVideoElasticSearchServiceOrigins,
  development: devVideoElasticSearchServiceOrigins,
  staging: productionVideoElasticSearchServiceOrigins,
  production: productionVideoElasticSearchServiceOrigins
};

// not defined here because node needs these in require format
// so we put them in the apiEnviroments file.
// const devGhostAPIOrigin = 'https://development.api.maxpreps.com';

// const ghostAPIOrigins = {
//   dev: devGhostAPIOrigin,
//   development: devGhostAPIOrigin,
//   staging: 'https://stag.api.maxpreps.com',
//   production: 'https://production.api.maxpreps.com'
// };
// export const ghostAPIOrigin = ghostAPIOrigins[appEnv];

export const adminOrigin = adminOrigins[appEnv];
export const publicOrigin = publicOrigins[appEnv];
export const secureOrigin = secureOrigins[appEnv];
export const imageOrigin = imageOrigins[appEnv];
export const videoElasticSearchOrigin =
  videoElasticSearchServiceOrigins[appEnv];
export const cdnOrigin = 'https://asset.maxpreps.io';
